module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-4-a84920ecb9b8648d967c1de09516adef.webp";